module.exports = __webpack_public_path__ + "img/img_logo_min.6af518b0.svg";